import React, { useState } from "react";
import { HeroLandingPage } from "../HeroLandingPage";
import { Carousel } from "../Carousel";
import { Trustpilot } from "../Trustpilot";
import { QuoteFormAndSafesitePromise } from "../QuoteFormAndSafesitePromise";
import { ContentLandingPage } from "../ContentLandingPage";
import { Faqs } from "../Faqs";
import { Video } from "../Video";
import { ContentAndMediaLandingPage } from "../ContentAndMediaLandingPage";
import { Accordion } from "../Accordion";
import { LocationList } from "../LocationList";
import { Media } from "../Media";
import { RelatedArticles } from "../RelatedArticles";
import { RelatedCaseStudies } from "../RelatedCaseStudies";
import { RelatedProducts } from "../RelatedProducts";
import { ThreeDView } from "../ThreeDView";
import { ProductGalleryAndPricing } from "../ProductGalleryAndPricing";
import { ProductTabs } from "../ProductTabs";
import { Table } from "../Table";
import { ProductList } from "../ProductList";
import { PricingBar } from "../PricingBar";
import { SpacerLandingPage } from "../SpacerLandingPage";
import { CustomTiles } from "../CustomTiles";
import { SubscribeToNewsletter } from "../SubscribeToNewsletter";
import { Accreditations } from "../Accreditations";
import { Filters } from "../Filters/Filters";

export const ProductComponent = ({ component, source, page }) => {
  if (component.fieldGroupName) {
    switch (component.fieldGroupName) {
      case "productCategory_Productcategorydata_Components_Filters":
        return page.products.nodes.length > 0 && (
          <Filters
            title={page.productCategoryData.filterTitle}
            subtitle={page.productCategoryData.filterSubtitle}
            showApplicationsFilter={page.productCategoryData.showApplicationsFilter}
            showDepthFilter={page.productCategoryData.showDepthFilter}
            showFilledWeightFilter={page.productCategoryData.showFilledWeightFilter}
            showHeightFilter={page.productCategoryData.showHeightFilter}
            showHeightWithFenceFilter={page.productCategoryData.showHeightWithFenceFilter}
            showWeightFilter={page.productCategoryData.showWeightFilter}
            showWidthFilter={page.productCategoryData.showWidthFilter}
            showCrashTestedFilter={page.productCategoryData.showCrashTestedFilter}
            showWindTunnelTestedFilter={page.productCategoryData.showWindTunnelTestedFilter}
            showChapter8Filter={page.productCategoryData.showChapter8Filter}
            crashTestedTooltip={page.productCategoryData.crashTestedTooltip}
            windTunnelTestedTooltip={page.productCategoryData.windTunnelTestedTooltip}
            chapter8Tooltip={page.productCategoryData.chapter8Tooltip}
          />
        );
      case "productCategory_Productcategorydata_Components_Products":
        return page.products.nodes.length > 0 && (
          <ProductList
            products={page.products.nodes}
            grey={component.background === 'grey'}
          />
        );
      case "product_Productdata_Components_PricingBar":
        return <PricingBar
          page={page}
        />;
      case "product_Productdata_Components_ProductGalleryAndPricing":
        return <ProductGalleryAndPricing
          product={page.productData}
          page={page}
          showStickyBar={false}
        />;
      case "product_Productdata_Components_Carousel":
      case "productCategory_Productcategorydata_Components_Carousel":
        return <Carousel
          images={component.images.map(image => image.image)}
          fullWidth={component.fullWidth}
          autoScroll={component.autoScroll}
          delay={component.delay}
        />;
      case "product_Productdata_Components_Faqs":
      case "productCategory_Productcategorydata_Components_Faqs":
        return <Faqs
          items={component.faqs}
          fullWidth={component.fullWidth}
          background={component.background}
        />;
      case "product_Productdata_Components_VideoComponent":
      case "productCategory_Productcategorydata_Components_VideoComponent":
        return <Video
          video={component.videoEmbed}
          aspectWidth={component.aspectWidth}
          aspectHeight={component.aspectHeight}
          fullWidth={component.fullWidth}
          background={component.background}
          title={component.title}
        />;
      case "product_Productdata_Components_Trustpilot":
      case "productCategory_Productcategorydata_Components_Trustpilot":
        return <Trustpilot
          background={component.background}
        />;
      case "product_Productdata_Components_QuoteFormAndSafesitePromise":
      case "productCategory_Productcategorydata_Components_QuoteFormAndSafesitePromise":
        return <QuoteFormAndSafesitePromise
          source={source}
        />;
      case "product_Productdata_Components_Table":
      case "productCategory_Productcategorydata_Components_Table":
        return <Table
          title={component.title}
          specifications={component.specifications}
          products={component.products}
          showProductFeaturedImageAndTitle={component.showProductFeaturedImageAndTitle}
        />;
      case "product_Productdata_Components_ProductTabs":
        const [tabState, setTabState] = useState("overview");

        return <ProductTabs
          product={page.productData}
          page={page}
          tabState={tabState}
          setTabState={setTabState}
        />;
      case "product_Productdata_Components_LocationList":
        return <LocationList
          products={page.wpChildren.nodes}
        />;
      case "productCategory_Productcategorydata_Components_LocationList":
        return <LocationList
          products={page.products.nodes}
        />;
      case "product_Productdata_Components_RelatedArticles":
      case "productCategory_Productcategorydata_Components_RelatedArticles":
        return <RelatedArticles
          articles={component.articles}
          inversed={component.background === 'white'}
        />;
      case "product_Productdata_Components_RelatedCaseStudies":
      case "productCategory_Productcategorydata_Components_RelatedCaseStudies":
        return <RelatedCaseStudies
          caseStudies={component.caseStudies}
          inversed={component.background === 'white'}
        />;
      case "product_Productdata_Components_RelatedProducts":
      case "productCategory_Productcategorydata_Components_RelatedProducts":
        return <RelatedProducts
          products={component.products}
          inversed={component.background === 'white'}
        />;
      case "product_Productdata_Components_ThreedView":
        if (!page.productData?.threeDView?.threeDViewEmbed) {
          return <p>Three D View for product not found</p>
        }

        return <ThreeDView
          threeDViewEmbed={page.productData.threeDView?.threeDViewEmbed}
          fullWidth={component.fullWidth}
        />;
      case "product_Productdata_Components_Media":
      case "productCategory_Productcategorydata_Components_Media":
        return <Media
          mobileColumns={component.mobileColumns}
          columns={component.columns}
          textAlign={component.textAlign}
          justifyContent={component.justifyContent}
          media={component.media}
          background={component.background}
          zoom={component.zoom}
        />;
      case "productCategory_Productcategorydata_Components_Accordion":
        return <Accordion
          accessories={component.accessories?.map((accessory) => { return { accessory: accessory } })}
          freeText={component.freeText}
          fullWidth={component.fullWidth}
          background={component.background}
          showReviews={false}
          showDownloads={false}
          showSpecifications={false}
          showApplications={false}
          page={page}
        />;
      case "product_Productdata_Components_Accordion":
        return <Accordion
          accessories={component.accessories?.map((accessory) => { return { accessory: accessory } })}
          freeText={component.freeText}
          fullWidth={component.fullWidth}
          background={component.background}
          showReviews={component.showReviews}
          showDownloads={component.showDownloads}
          showSpecifications={component.showSpecifications}
          showApplications={component.showApplications}
          page={page}
        />;
      case "product_Productdata_Components_ContentAndImage":
      case "productCategory_Productcategorydata_Components_ContentAndImage":
        return <ContentAndMediaLandingPage
          title={component.titleGroup}
          titleLink={component.titleLink}
          content={component.content}
          list={component.list}
          button={component.button}
          image={component.image}
          imageLink={component.imageLink}
          placement={component.placement}
          background={component.background}
          mediaType={component.mediaType}
          video={component.video?.publicUrl}
          videoPoster={component.videoPoster}
          oembed={component.oembed}
          carouselImages={component.carouselImages}
          autoScroll={component.autoScroll}
          delay={component.delay}
        />;
      case "product_Productdata_Components_Content":
      case "productCategory_Productcategorydata_Components_Content":
        return <ContentLandingPage
          title={component.titleGroup}
          content={component.content}
          background={component.background}
          images={component.images}
          align={component.align}
        />;
      case "product_Productdata_Components_Hero":
      case "productCategory_Productcategorydata_Components_Hero":
        return <HeroLandingPage
          title={component.titleGroup}
          content={component.content}
          button={component.button}
          desktopImage={component.desktopImage?.mediaItemUrl}
          mobileImage={component.mobileImage?.mediaItemUrl}
          fullHeight={component.fullHeight}
          overlayColour={component.overlayColour}
          overlayOpacity={component.overlayOpacity}
          video={component.videoFile?.publicUrl}
          videoPoster={component.videoPoster}
          background={component.background}
          mobileBackground={component.mobileBackground}
          uppercaseTitle={component.uppercaseTitle}
          darkText={component.darkText}
          textShadow={component.textShadow}
          carouselImages={component.carouselImages}
          autoScroll={component.autoScroll}
          delay={component.delay}
        />;
      case "product_Productdata_Components_Spacer":
      case "productCategory_Productcategorydata_Components_Spacer":
        return <SpacerLandingPage
          background={component.background}
        />;
      case "product_Productdata_Components_CustomTiles":
      case "productCategory_Productcategorydata_Components_CustomTiles":
        return <CustomTiles
          overhang={component.overhang}
          overhangMobile={component.overhangMobile}
          background={component.background}
          title={component.titleGroup}
          content={component.content}
          button={component.button}
          products={component.products}
        />;
      case "product_Productdata_Components_SubscribeToNewsletter":
      case "productCategory_Productcategorydata_Components_SubscribeToNewsletter":
        return <SubscribeToNewsletter
          background={component.background}
          title={component.title}
          subText={component.subText}
          disclaimer={component.disclaimer}
          confirmation={component.confirmation}
          icon={component.icon}
          image={component.image}
        />;
      case "product_Productdata_Components_Accreditations":
      case "productCategory_Productcategorydata_Components_Accreditations":
        return <Accreditations
          global={component.global}
          images={component.images}
          autoScroll={component.autoScroll}
          delay={component.delay}
        />;
      default:
        return <></>;
    }
  }
};
